/* eslint-disable react/jsx-max-props-per-line */
import type React from 'react';
import { useEffect, useState } from 'react';

import { useGetFaceAttributeSamples, useSdk } from '@vlabs/api/luna-api/client';
import type { FaceId, OneImageEstimation, SdkResponseJson } from '@vlabs/api/luna-api/model';
import { useTranslation } from 'react-i18next';

import { EmotionsValue } from './EmotionsValue';
// import { EyesValue } from './EyesValue';
import st from './FaceAdditionalAttributes.module.sass';
import { MouthValue } from './MouthValue';
import { AttributeInfoRow } from '../attribute-info-row/AttributeInfoRow';

interface FaceAdditionalAttributesProps {
  faceId: FaceId;
}

function FaceAdditionalAttributes({
  faceId,
}: FaceAdditionalAttributesProps): React.JSX.Element {
  const { t } = useTranslation();
  const [extractedAttributes, setExtractedAttributes] = useState<SdkResponseJson>();
  const getFaceSamples = useGetFaceAttributeSamples(faceId);
  const { mutate: requestSDK } = useSdk({
    mutation: {
      onSuccess: setExtractedAttributes,
      onError: () => setExtractedAttributes(undefined),
    },
  });
  const faceAttributes = (extractedAttributes?.images_estimations?.[0] as OneImageEstimation)
    ?.estimations?.[0]?.face?.detection.attributes;
  const qualityAttributes = (extractedAttributes?.images_estimations?.[0] as OneImageEstimation)
    ?.estimations?.[0]?.face?.detection.quality;

  useEffect(() => {
    if (!getFaceSamples.data?.samples) return;

    requestSDK({
      data: { samples: getFaceSamples.data.samples },
      params: {
        image_type: 1,
        estimate_quality: 1,
        estimate_mouth_attributes: 1,
        estimate_emotions: 1,
        estimate_glasses: 1,
        // не работает на варпах
        // estimate_eyes_attributes: 1,
        // estimate_head_pose: 1
        // estimate_gaze: 1,
      },
    });
  }, [getFaceSamples.data?.samples, requestSDK]);

  return (
    <div className={st.Root}>
      <AttributeInfoRow title={t('light_quality')} value={qualityAttributes?.light} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('dark_quality')} value={qualityAttributes?.dark} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('blur_quality')} value={qualityAttributes?.blurriness} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('specularity')} value={qualityAttributes?.specularity} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('illumination_quality')} value={qualityAttributes?.illumination} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('mouth_state')} value={<MouthValue mouthAttributes={faceAttributes?.mouth_attributes} />} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('emotion')} value={<EmotionsValue emotions={faceAttributes?.emotions} />} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('glasses')} value={t(`glasses_states.${faceAttributes?.glasses?.glasses}`)} />
      {/*
      // не работает на варпах
      <span className={st.Divider} />
      <InfoRow title={t('gaze_direction_pitch')} value={faceAttributes?.gaze?.pitch} />
      <span className={st.Divider} />
      <InfoRow title={t('gaze_direction_yaw')} value={faceAttributes?.gaze?.yaw} />
      <span className={st.Divider} />
      <InfoRow title={t('eye_state')} value={<EyesAttributes eyesAttributes={faceAttributes?.eyes_attributes} />} />
      */}
    </div>
  );
}

export { FaceAdditionalAttributes };
